﻿interface OnBodyClickCallbackReference
{
	ref: DotNet.DotNetObject;
	method: string;
	ignoreIDs: string[];
}

const onBodyClickCallbackElements: OnBodyClickCallbackReference[] = [];

async function HandleOnBodyClicked(ev: MouseEvent) {
    for (let i = 0; i < onBodyClickCallbackElements.length; ++i) {
        const c = onBodyClickCallbackElements[i];
        let ignore = false;

        if (c.ignoreIDs.length > 0) {
            let el = ev.target as HTMLElement;
            while (el.parentElement) {
                if (c.ignoreIDs.includes(el.id)) {
                    ignore = true;
                    break;
                }

                el = el.parentElement;
            }
        }

        if (!ignore) {
            try {
                await c.ref.invokeMethodAsync(c.method, ev);
            } catch {
                // Something is broken, so remove this entry
                onBodyClickCallbackElements.splice(i, 1);
                --i;
            }
        }
    }
}

document.body.addEventListener("click", (ev) => HandleOnBodyClicked(ev));

export class ElementUtilities
{
	registerOnBodyClickCallback(dotNetRef: DotNet.DotNetObject, methodToinvoke: string, ignoreIDs: string[])
    {
        const filteredIgnoreIDs: string[] = [];

        if (ignoreIDs) {
            for (const id of ignoreIDs) {
                if (id && id.length > 0) {
                    filteredIgnoreIDs.push(id);
                }
            }
        }

		onBodyClickCallbackElements.push({
			ref: dotNetRef,
			method: methodToinvoke,
            ignoreIDs: filteredIgnoreIDs,
		});
	}

	unregisterOnBodyClickCallback(dotNetRef: DotNet.DotNetObject)
	{
		for (let i = 0; i < onBodyClickCallbackElements.length; ++i)
		{
			if (onBodyClickCallbackElements[i].ref["_id"] == dotNetRef["_id"])
			{
				onBodyClickCallbackElements.splice(i, 1);
				--i;
			}
		}
	}

	scrollElementIntoView(selector: string, smooth: boolean = true, delay: number = 0)
	{
		setTimeout(() =>
		{
			document.querySelectorAll(selector).forEach((el) =>
			{
				el.scrollIntoView({
					behavior: smooth ? "smooth" : "auto",
					block: "nearest",
					inline: "nearest",
				});
			});
		}, delay);
	}

	overflowScrollToTop(elementID: string)
	{
		let element = document.getElementById(elementID);

		if (element != null)
		{
			element.scrollTop = 0;
		}
	}
}